/* eslint-disable no-restricted-globals */
/* eslint-disable import/prefer-default-export */
import { get } from 'lodash';

import {
  LIST_ENROLLMENT_PLANNING_ACTIVITY_LOG,
  LIST_ENROLLMENT_PLANNING_CHANGE_REQUESTS,
  LIST_ENROLLMENT_PLANNING_UTILISATION,
  CREATE_ENROLLMENT_PLANNING_REQUEST,
  APPROVE_ENROLLMENT_PLAN,
  REJECT_ENROLLMENT_PLAN,
} from '../models/enrolmentPlanningModel';
import {
  GET_LIST_ENROLLMENT_PLANNING_CHANGE_REQUESTS_LOADING,
  GET_LIST_ENROLLMENT_PLANNING_CHANGE_REQUESTS_SUCCESS,
  GET_LIST_ENROLLMENT_PLANNING_CHANGE_REQUESTS_ERROR,
  GET_ENROLLMENT_PLANNING_UTILISATION_LOADING,
  GET_ENROLLMENT_PLANNING_UTILISATION_SUCCESS,
  GET_ENROLLMENT_PLANNING_UTILISATION_ERROR,
  GET_LIST_ENROLLMENT_PLANNING_ACTIVITY_LOG,
} from './actionTypes';
import { SkApolloRequest } from '../../utils/apolloUtils';
import {
  msGetEnrollmentPlansByYear,
  msGetListEnrollmentPlanningRequests,
  msGetEnrolmentPlanningUtilisation,
  msGetListEnrollmentPlanningActivityLog,
  msApproveEnrollmentPlan,
  msRejectEnrollmentPlan,
  msCreateEnrollmentPlanning,
} from '../../services/EnrolmentPlanningService';
import DatadogHandler from '../../utils/datadog';
import { actionHandlerWithFeatureFlag } from '../../utils';
import { FEATURE_FLAGS } from '../../utils/constants';

const getEnrolmentPlanningUtilisationLoading = () => ({
  type: GET_ENROLLMENT_PLANNING_UTILISATION_LOADING,
  value: {
    inProgress: true,
    error: null,
    data: [],
  },
});

const getEnrolmentPlanningUtilisationSuccess = data => ({
  type: GET_ENROLLMENT_PLANNING_UTILISATION_SUCCESS,
  value: {
    inProgress: false,
    data,
  },
});

const getEnrolmentPlanningUtilisationError = error => ({
  type: GET_ENROLLMENT_PLANNING_UTILISATION_ERROR,
  value: {
    inProgress: false,
    error,
  },
});

const getListEnrollmentPlanningRequestsLoading = () => ({
  type: GET_LIST_ENROLLMENT_PLANNING_CHANGE_REQUESTS_LOADING,
  value: {
    inProgress: true,
    error: null,
    data: [],
  },
});

const getListEnrollmentPlanningRequestsSuccess = data => ({
  type: GET_LIST_ENROLLMENT_PLANNING_CHANGE_REQUESTS_SUCCESS,
  value: {
    inProgress: false,
    data,
  },
});

const getListEnrollmentPlanningRequestsError = error => ({
  type: GET_LIST_ENROLLMENT_PLANNING_CHANGE_REQUESTS_ERROR,
  value: {
    inProgress: false,
    error,
  },
});

const dispatchListActivityLogEnrollmentPlaning = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: GET_LIST_ENROLLMENT_PLANNING_ACTIVITY_LOG,
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const monoGetEnrolmentPlanningUtilisation = async (
  dispatch,
  { centreID, year }
) => {
  try {
    const res = await SkApolloRequest({
      params: {
        query: LIST_ENROLLMENT_PLANNING_UTILISATION,
        variables: { centreID, year },
      },
      type: 'query',
    });
    return res;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');

    dispatch(getEnrolmentPlanningUtilisationError(ex.message));
    return ex;
  }
};

export const getEnrolmentPlanningUtilisation =
  ({ centreID, year }) =>
  async dispatch => {
    dispatch(getEnrolmentPlanningUtilisationLoading());
    try {
      const res = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msGetEnrolmentPlanningUtilisation,
          monoHandler: monoGetEnrolmentPlanningUtilisation,
          extraData: { centreID, year },
        }
      );
      if (res.success) {
        const data = get(res, 'data.getEnrolmentPlanningUtilisation');
        dispatch(getEnrolmentPlanningUtilisationSuccess(data));
      } else {
        dispatch(
          getEnrolmentPlanningUtilisationError(get(res, 'error.0.message'))
        );
      }
      return res;
    } catch (ex) {
      return ex;
    }
  };

export const monoGetListEnrollmentPlanningRequests = async (
  dispatch,
  filter
) => {
  try {
    const res = await SkApolloRequest({
      params: {
        query: LIST_ENROLLMENT_PLANNING_CHANGE_REQUESTS,
        variables: { filter },
      },
      type: 'query',
    });
    return res;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');
    dispatch(getListEnrollmentPlanningRequestsError(ex.message));
    return ex;
  }
};

export const getListEnrollmentPlanningRequests = filter => async dispatch => {
  dispatch(getListEnrollmentPlanningRequestsLoading());
  try {
    const res = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetListEnrollmentPlanningRequests,
        monoHandler: monoGetListEnrollmentPlanningRequests,
        extraData: filter,
      }
    );
    if (res.success) {
      const data = get(res, 'data.listEnrollmentPlanningChangeRequests');
      dispatch(getListEnrollmentPlanningRequestsSuccess(data));
    } else {
      dispatch(
        getListEnrollmentPlanningRequestsError(get(res, 'error.0.message'))
      );
    }
    return res;
  } catch (ex) {
    return ex;
  }
};

export const monoGetListEnrollmentPlanningActivityLog = async (
  dispatch,
  { schoolID, pagination, filter, excludeEmptySnap }
) => {
  try {
    const res = await SkApolloRequest({
      params: {
        query: LIST_ENROLLMENT_PLANNING_ACTIVITY_LOG,
        variables: { schoolID, pagination, filter, excludeEmptySnap },
      },
      type: 'query',
    });

    return res;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');

    dispatch(getListEnrollmentPlanningRequestsError(ex.message));
    return ex;
  }
};

export const getListEnrollmentPlanningActivityLog =
  (schoolID, pagination, filter, excludeEmptySnap) => async dispatch => {
    dispatchListActivityLogEnrollmentPlaning(dispatch);
    try {
      const res = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msGetListEnrollmentPlanningActivityLog,
          monoHandler: monoGetListEnrollmentPlanningActivityLog,
          extraData: { schoolID, pagination, filter, excludeEmptySnap },
        }
      );
      if (res.success) {
        const data = get(res, 'data.capacityDraftsByFkSchool');
        dispatchListActivityLogEnrollmentPlaning(dispatch, false, data);
      } else {
        dispatch(
          dispatchListActivityLogEnrollmentPlaning(
            dispatch,
            false,
            get(res, 'error.0.message')
          )
        );
      }
      return res;
    } catch (ex) {
      return ex;
    }
  };

export const getEnrollmentPlansByYear = reqData => async dispatch =>
  msGetEnrollmentPlansByYear(dispatch, reqData);

export const monoRejectEnrollmentPlan = async ({ draftID, rejectRemark }) =>
  SkApolloRequest({
    params: {
      mutation: REJECT_ENROLLMENT_PLAN,
      variables: {
        draftID,
        rejectRemark,
      },
    },
    type: 'mutation',
  });

export const rejectEnrollmentPlan = async ({ draftID, rejectRemark }) => {
  const result = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: (_, reqBody) => msRejectEnrollmentPlan(reqBody),
      monoHandler: (_, reqBody) => monoRejectEnrollmentPlan(reqBody),
      extraData: {
        draftID,
        rejectRemark,
      },
    }
  );
  return result;
};

export const monoApproveEnrollmentPlan = async ({
  draftID,
  isValidatingExceeding,
}) =>
  SkApolloRequest({
    params: {
      mutation: APPROVE_ENROLLMENT_PLAN,
      variables: {
        draftID,
        isValidatingExceeding,
      },
    },
    type: 'mutation',
  });

export const approveEnrollmentPlan = async ({
  draftID,
  isValidatingExceeding,
}) => {
  const result = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: (_, reqBody) => msApproveEnrollmentPlan(reqBody),
      monoHandler: (_, reqBody) => monoApproveEnrollmentPlan(reqBody),
      extraData: {
        draftID,
        isValidatingExceeding,
      },
    }
  );
  return result;
};

export const monoCreateEnrollmentPlanning = async ({
  centreID,
  levelID,
  programID,
  update,
  isValidatingExceeding,
}) =>
  SkApolloRequest({
    params: {
      mutation: CREATE_ENROLLMENT_PLANNING_REQUEST,
      variables: {
        centreID,
        levelID,
        isValidatingExceeding,
        programID,
        update,
      },
    },
    type: 'mutation',
  });

export const createEnrollmentPlanningRequest = async ({
  centreID,
  levelID,
  programID,
  update,
  isValidatingExceeding,
}) => {
  const result = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: (_, reqBody) => msCreateEnrollmentPlanning(reqBody),
      monoHandler: (_, reqBody) => monoCreateEnrollmentPlanning(reqBody),
      extraData: {
        centreID,
        levelID,
        programID,
        update,
        isValidatingExceeding,
      },
    }
  );
  return result;
};
